module.exports = __webpack_public_path__ + "static/media/hybrid-car.f94ae86f.svg";